import { ComprehensiveStatsDashboard } from '@/components/ComprehensiveStatsDashboard'
import { BarChart3, Home } from 'lucide-react'
import { useNavigate } from 'react-router'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'

export default function StatisticsPage() {
    const navigate = useNavigate()

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white">
            {/* Hero Header */}
            {/* Enhanced Header Section */}
            <div className="relative bg-gradient-to-r from-blue-600 via-indigo-700 to-purple-800 overflow-hidden">
                <div className="absolute inset-0 bg-black/10">
                    <div className="absolute inset-0 bg-white/5"></div>
                </div>

                {/* Decorative Elements */}
                <div className="absolute top-0 right-0 -mt-20 -mr-20 w-80 h-80 bg-white/5 rounded-full"></div>
                <div className="absolute bottom-0 left-0 -mb-32 -ml-32 w-64 h-64 bg-white/5 rounded-full"></div>

                <div className="relative container mx-auto px-6 py-16">
                    <div className="max-w-4xl">
                        <div className="flex items-center space-x-3 mb-6">
                            <div className="p-3 bg-white/20 rounded-xl backdrop-blur-sm border border-white/20">
                                <BarChart3 className="h-8 w-8 text-white" />
                            </div>
                            <div className="flex items-center space-x-2 text-white/80 text-sm">
                                <div className="w-2 h-2 bg-white/60 rounded-full"></div>
                                <span>Dashboard</span>
                                <div className="w-2 h-2 bg-white/60 rounded-full"></div>
                                <span>Detail Statistik</span>
                            </div>
                        </div>

                        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight">
                            Dashboard Statistik
                        </h1>

                        <p className="text-xl text-white/90 mb-8 leading-relaxed max-w-3xl">
                            Analisis komprehensif data demografis, pendidikan, pekerjaan, dan keagamaan dalam satu tampilan terpadu
                        </p>

                        {/* Action Button */}
                        <div className="flex flex-wrap gap-4">
                            <Button
                                className="bg-white/20 hover:bg-white/30 text-white border border-white/30 backdrop-blur-sm font-semibold px-6 py-3 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl"
                                onClick={() => navigate('/')}
                            >
                                <Home className="h-5 w-5 mr-2" />
                                Kembali ke Beranda
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Content Area */}
            <div className="container mx-auto px-6 py-8">
                <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
                    <div className="p-8">
                        <ComprehensiveStatsDashboard />
                    </div>
                </div>
                
                {/* Information Card */}
                <div className="mt-8">
                    <Card className="bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 border border-blue-200 shadow-lg rounded-2xl">
                        <CardContent className="p-8">
                            <div className="text-center">
                                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                                    Dashboard Statistik Desa
                                </h3>
                                <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
                                    Data real-time statistik demografis, pendidikan, pekerjaan, dan agama masyarakat berdasarkan pencatatan terkini
                                </p>
                                <div className="flex flex-wrap gap-4 justify-center">
                                    <Button 
                                        className="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white rounded-xl px-6 py-3 shadow-lg font-semibold"
                                        onClick={() => navigate('/')}
                                    >
                                        <Home className="h-5 w-5 mr-2" />
                                        Kembali ke Beranda
                                    </Button>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                </div>
            </div>
        </div>
    )
}
